import * as React from "react";
const SvgArrowLongLeft = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1.8125rem", height: "0.75rem", viewBox: "0 0 29 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M28.5 6H1.5M1.5 6L6 0.5M1.5 6L6 11.5", stroke: "#697586", strokeWidth: 1.5 }));
export default SvgArrowLongLeft;
